import createTransition from 'shared-tokens/utils/createTransition';
import createBreakpoint from 'shared-tokens/utils/breakpoints';

import { mainCls as cardCls } from '../../style';

const brTablet = createBreakpoint('s');

export const mainCls = `${cardCls}__det`;
export const mapCls = `map_${cardCls}__det`;

export default {
  [mainCls]: {
    flex: '1 1 0%',
    padding: 12,
    
    [brTablet]: {
      padding: '12px 16px 8px',
      transition: createTransition(['min-height']),
    },
  },
  [`${mainCls}__cont`]: {
    height: '100%',
  },
  [`${mainCls}__infos`]: {
    marginTop: 16,
    [brTablet]: {
      marginTop: 0,
      minHeight: '100%',
    },
  },
  [`${mapCls}__infos`]: {
    marginTop: 16,
    [brTablet]: {
      marginTop: 12,
    },
  },
};
